import { Carousel } from 'react-responsive-carousel'
import styled, { keyframes } from 'styled-components'

import { BREAKPOINTS } from 'resources/constants'

const PREVIOUS_SECTION_BG_COLOR = '#f0eaf3'

export const VenueWrapper = styled.section`
	position: relative;
	padding-top: 80px;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		background: ${PREVIOUS_SECTION_BG_COLOR};
		height: 50px;
	}

	&::after {
		content: '';
		border-top-left-radius: 50% 100%;
		border-top-right-radius: 50% 100%;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		background: #fff;
		height: 50px;
		box-shadow: 0px -5px 4px rgba(125, 125, 125, 0.15);
	}
`

export const VenueContainer = styled.div`
	display: grid;
	grid-gap: 40px;
	padding: 0 15px 60px;

	@media only screen and (min-width: ${BREAKPOINTS.lg}) {
		grid-template-columns: 1fr 1fr;
	}
	@media only screen and (min-width: ${BREAKPOINTS.xl}) {
		grid-template-columns: 1.5fr 1fr;
	}
`

/** @type {Carousel} */
export const VenueCarousel = styled(Carousel)`
	.control-dots {
		display: flex;
		justify-content: center;
		align-items: center;
		background: linear-gradient(0deg, rgba(0, 0, 0, 0.6), transparent);
		padding: 40px 0 20px;
		margin: 0;
	}
`

export const CarouselIndicator = styled.div`
	height: 5px;
	width: 40px;
	background-color: white;
	opacity: ${({ selected }) => (selected ? 1 : 0.7)};
	transition: all 0.3s ease-in-out;
	margin: 0 5px;
	cursor: pointer;

	&:hover {
		opacity: 1;
	}
`

export const VenueImage = styled.img`
	height: auto;
	width: 100%;
`

export const VenueDetailsContainer = styled.div`
	display: flex;
	flex-direction: column;
	background-color: #fff;
	box-shadow: 0 0 10px 2px rgba(0, 0, 0, 10%);
	padding: 30px 20px;
`

export const VenueDetails = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	margin-bottom: 10px;
	justify-content: space-between;
`

export const DetailItem = styled.div`
	display: flex;
	flex: 1;
`

export const DetailIconContainer = styled.div`
	display: flex;
	flex-direction: column;
	flex: none;
`

export const DetailIcon = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	width: 50px;
	height: 50px;
	background-color: hsl(351, 34%, 70%);
	padding: 10px;

	i {
		color: white;
		font-size: 1.5rem;
	}
`

export const DetailLineContainer = styled.div`
	position: relative;
	flex: 1;
`

export const DetailLine = styled.svg`
	height: 100%;
	width: 2px;
	position: absolute;
	top: 0;
	left: 50%;
	transform: translateX(-50%);

	line {
		stroke: hsl(351, 34%, 90%);
		stroke-width: 2;
		stroke-dasharray: 3 4;
		stroke-linecap: round;
	}
`

export const DetailText = styled.div`
	flex: 1;
	padding: 0 0 30px 15px;

	h3 {
		font-weight: bold;
		font-size: 1.2rem;
		font-family: 'Trajan Pro', sans-serif;
	}

	p {
		margin-bottom: 0;
	}
`

const pulseAnimation = keyframes`
	0% {
    box-shadow: 0 0 0 0px hsl(351, 34%, 70%);
  }
  100% {
    box-shadow: 0 0 0 20px transparent;
  }
`

export const MapMarker = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 55px;
	height: 55px;
	background-color: hsl(351, 34%, 70%);
	border-radius: 50%;
	animation: ${pulseAnimation} 2s infinite;
`

export const MapMarkerIcon = styled.i`
	font-size: 2rem;
	color: white;
`
